import {toggle_class} from "./helpers";
import {aspect_ratio} from "./helpers";
function readyHTML() {
    toggle_class('.full-screen', '.slot-description', 'full-screen-iframe');
    toggle_class('.full-screen', 'body', 'overflow-hidden');
    toggle_class('.full-screen', '#heatmapthemead-main', 'z-index-change');
    toggle_class('.full-screen-overlay', '.slot-description', 'full-screen-iframe');
    toggle_class('.full-screen-overlay', '#heatmapthemead-main', 'z-index-change');
    toggle_class('.full-screen-overlay', 'body', 'overflow-hidden');

    aspect_ratio('.preload-img img');
    aspect_ratio('.iframe iframe');
}

document.addEventListener("DOMContentLoaded", readyHTML);

//Lazy load for background images
document.addEventListener('lazybeforeunveil', function(e){
    let bg = e.target.getAttribute('data-bg');
    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
});